export const ROOT_PATH = "/";
export const HOME_PATH = "/home";
export const SIGNIN_PATH = "/auth";
export const DEMO_PATH = "/demo";
export const HELP_PATH = "/help";
export const PRIVACY_PATH = "/privacy";
export const TERMS_PATH = "/terms";
export const FEEDBACK_PATH = "/feedback";
